import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import CommercePage from "./pages/commerce/CommercePage";
import AdminPanel from "./pages/adminPanel/AdminPanel";
import Order from "./pages/order/Order";
import PendingOrder from "./pages/pendingOrder/PendingOrder";
import CompletedOrder from "./pages/completedOrder/CompletedOrder";
import OrderDetails from "./pages/orderDetails/OrderDetails";
import ProductDetailsPage from "./pages/productDetailsPage/ProductDetailsPage";
import AddProductDetails from "./pages/addProductDetails/AddProductDetails";
import Products from "./pages/products/Products";
import CategoryMgmt from "./pages/categoryMgmt/CategoryMgmt";

import Offers from "./pages/offers/Offers";
import ActiveOffer from "./pages/activeOffer/ActiveOffer";
import InActiveOffer from "./pages/inActiveOffer/InActiveOffer";
import EditOffer from "./pages/editOffer/EditOffer";
import Customers from "./pages/customers/Customers";
import AddCustomer from "./pages/addCustomer/AddCustomer";
import Reviews from "./pages/reviews/Reviews";
import UserManagement from "./pages/userManagement/UserManagement";
import AddUser from "./pages/addUser/AddUser";
import ActiveBanner from "./pages/activeBanner/ActiveBanner";
import InActiveBanner from "./pages/inActiveBanner/InActiveBanner";
import Banners from "./pages/banners/Banners";
import ReviewProductDetailsPage from "./pages/reviewPeoductDetailsPage/ReviewProductDetailsPage";
import CustomerOrderDetails from "./pages/customerOrderDetails/CustomerOrderDetails";
import { Toaster } from "react-hot-toast";
import Settings from "./pages/settings/Settings";
import EditUser from "./pages/settings/EditUser";
import Leads from "./pages/leads/Leads";
import LeadDetails from "./pages/leaddetails/LeadDetails";
import DispatcherOrder from "./pages/dispatcherorder/DispatcherOrder";
import DispatcherPendingOrder from "./pages/dispatcherPendingOrder/DispatcherPendingOrder";
import DispatcherCompletedOrder from "./pages/dispatcherCompletedOrder/DispatcherCompletedOrder";
import PackagerPendingOrder from "./pages/packagerPendingOrder/PackagerPendingOrder";
import PackagerCompletedOrder from "./pages/packagerCompletedOrder/PackagerCompletedOrder";
import PackagerOrder from "./pages/packagerOrder/PackagerOrder";
import DashBoard from "./pages/dashBoard/DashBoard";
import DispatcherIntransitOrder from "./pages/dispatcherIntransitOrder/DispatcherIntransitOrder";
import Blog from "./pages/blogs/Blog";
import ActiveBlog from "./pages/activeBlog/ActiveBlog";
import InActiveBlog from "./pages/inActiveBlog/InActiveBlog";
import BlogCategories from "./pages/blogCategories/BlogCategories";
import ActiveBlogCategories from "./pages/activeBlogCategories/ActiveBlogCategories";
import InActiveBlogCategories from "./pages/inActiveBlogCategories/InActiveBlogCategories";
import StateManagement from "./pages/stateManagement/StateManagement";
import ManageBlog from "./components/customComponents/manageBlog/ManageBlog";
import AdminPanelOne from "./pages/adminPanelOne/AdminPanelOne";
import LoginNew from "./pages/loginNew/LoginNew";
import SsoCallback from "./pages/sso/SsoCallback";
import OrderPage from "./pages/orderPage/OrderPage";
import TimeStamp from "./components/uiComponents/timeStamp/TimeStamp";
import AddressTile from "./components/uiComponents/addressTile/AddressTile";
import CartBundleTile from "./components/uiComponents/cartBundleTile/CartBundleTile";
import CartBundleDetails from "./pages/cartBundleDetails/CartBundleDetails";
import CartBundleOrders from "./pages/cartBundleOrders/CartBundleOrders";
import CartBundleOrdersPackager from "./pages/cartBundleOrderPackager/CartBundleOrderPackager";
import OrderPagePackager from "./pages/orderPagePackager/OrderPagePackager";
import CartBundleDetailsPackager from "./pages/cartBundleDetailsPackager/CartBundleDetailsPackager";
import CartBundleOrdersDispatcher from "./pages/cartBundleOrderDispatcher/CartBundleOrderDispatcher";
import OrderPageDispatcher from "./pages/orderPageDispatcher/OrderPageDispatcher";
import CartBundleDetailsDispatcher from "./pages/cartBundledetailsDispatcher/CartBundleDetailsDispatcher";
import CompletedOrderPage from "./pages/completedOrderPage/CompletedOrderPage";
import CompletedOrderPackager from "./pages/completedOrderPackager/CompletedOrderPackager";
import CompletedOrderDispatcher from "./pages/completedOrderDispatcher/CompletedOrderDispatcher";
import OrderTransitDispatcher from "./pages/orderTransitDispatcher/OrderTransitDispatcher";
import ProductList from "./pages/productList/ProductList";
import ProductDisabled from "./pages/productDisabled/ProductDisabled";
import ProductDeleted from "./pages/productDeleted/ProductDeleted";
import ProductMgmt from "./pages/productMgmt/ProductMgmt";
import RaiseTicketPage from "./pages/raiseTicketPage/RaiseTicketPage";
import PendingTicktets from "./pages/pendingTickets/PendingTicktets";
import CompletedTickets from "./pages/completedTickets/CompletedTickets";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {" "}
        <Route path="/" element={<AdminPanelOne />}>
          <Route path="" element={<DashBoard />} />
          <Route path="order" element={<Order />}>
            <Route path="" element={<PendingOrder />} />
            <Route path="completed" element={<CompletedOrder />} />
          </Route>
          {/* admin */}
          <Route path="cartBundleOrders" element={<Outlet />}>
            <Route path="" element={<CartBundleOrders />}>
              <Route path="" element={<OrderPage />} />
              <Route path="completed" element={<CompletedOrderPage />} />
            </Route>
            <Route path="cartBundleDetails" element={<CartBundleDetails />} />
          </Route>
          {/* packager */}
          <Route path="cartBundleOrdersPackager" element={<Outlet />}>
            <Route path="" element={<CartBundleOrdersPackager />}>
              <Route path="" element={<OrderPagePackager />} />
              <Route path="completed" element={<CompletedOrderPackager />} />
            </Route>
            <Route
              path="cartBundleDetailsPackager"
              element={<CartBundleDetailsPackager />}
            />
          </Route>
          {/* dispatcher */}
          <Route path="cartBundleOrdersDispatcher" element={<Outlet />}>
            <Route path="" element={<CartBundleOrdersDispatcher />}>
              <Route path="" element={<OrderPageDispatcher />} />
              <Route path="inTransit" element={<OrderTransitDispatcher />} />
              <Route path="completed" element={<CompletedOrderDispatcher />} />
            </Route>
            <Route
              path="cartBundleDetailsDispatcher"
              element={<CartBundleDetailsDispatcher />}
            />
          </Route>

          <Route path="commerce/:module" element={<CommercePage />} />
          <Route path="state" element={<StateManagement />} />
          <Route path="dispatcherorder" element={<DispatcherOrder />}>
            <Route path="" element={<DispatcherPendingOrder />} />
            <Route path="intransit" element={<DispatcherIntransitOrder />} />
            <Route
              path="dispatchercompleted"
              element={<DispatcherCompletedOrder />}
            />
          </Route>
          <Route path="packagerorder" element={<PackagerOrder />}>
            <Route path="" element={<PackagerPendingOrder />} />
            <Route
              path="packagercompleted"
              element={<PackagerCompletedOrder />}
            />
          </Route>

          <Route path="setting" element={<Settings />} />
          {/* <Route path="leads" element={<Leads />}/> */}
          <Route path="leads" element={<Outlet />}>
            <Route path="" element={<Leads />} />
            <Route path="leaddetails" element={<LeadDetails />} />
          </Route>

          <Route path="orderdetails" element={<OrderDetails />} />
          <Route path="offer" element={<Offers />}>
            <Route path="" element={<ActiveOffer />} />
            <Route path="inActive" element={<InActiveOffer />} />
          </Route>
          <Route path="editOffer" element={<EditOffer />} />
          <Route path="products" element={<Outlet />}>
            <Route path="" element={<Products />} />
            <Route path="category" element={<CategoryMgmt />} />
            <Route path="productdetails" element={<ProductDetailsPage />} />
            <Route path="addproductDetails" element={<AddProductDetails />} />

            <Route path="productMgmt" element={<ProductList />}>
              <Route path="" element={<ProductMgmt />} />
              <Route path="disabled" element={<ProductDisabled />} />
              <Route path="deleted" element={<ProductDeleted />} />
            </Route>
            {/* <Route path="productMgmt" element={<productMgmt />} /> */}
          </Route>

          <Route path="customers" element={<Outlet />}>
            <Route path="" element={<Customers />} />
            <Route
              path="CustomerOrderDetails"
              element={<CustomerOrderDetails />}
            />
          </Route>
          <Route path="reviews" element={<Outlet />}>
            <Route path="" element={<Reviews />} />
          </Route>
          <Route path="userManagement" element={<Outlet />}>
            <Route path="" element={<UserManagement />} />
            <Route path="addUser" element={<AddUser />} />
            <Route path="editUser" element={<EditUser />} />
          </Route>
          <Route path="banner" element={<Banners />}>
            <Route path="" element={<ActiveBanner />} />
            <Route path="inActive" element={<InActiveBanner />} />
          </Route>
          <Route path="blog" element={<Blog />}>
            <Route path="" element={<ActiveBlog />} />
            <Route path="inActive" element={<InActiveBlog />} />
          </Route>
          <Route path="blogCategories" element={<BlogCategories />}>
            <Route path="" element={<ActiveBlogCategories />} />
            <Route path="inActive" element={<InActiveBlogCategories />} />
          </Route>
          <Route
            path="reviewproductdetails"
            element={<ReviewProductDetailsPage />}
          />
          <Route path="raiseTicket" element={<RaiseTicketPage />}>
            <Route path="" element={<PendingTicktets />} />
            <Route path="completed" element={<CompletedTickets />} />
          </Route>
        </Route>
        <Route path="/login" element={<LoginNew />} />
        <Route path="/callback" element={<SsoCallback />} />
        {/* <Route path="/login" element={<Login />} /> */}
        <Route path="/blogManage" element={<ManageBlog />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
